import React, { useEffect } from 'react';
import classNames from 'classnames';
import {  message } from 'antd';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'hooks';
import qs from 'query-string';
import Loading from 'components/molecules/Loading';
import { useNavigate } from 'react-router-dom';


const cx = classNames.bind('./index.scss');

export interface ActivateProps {}

const Activate = ({}: React.PropsWithChildren<ActivateProps>): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const { activate } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    const activateParams = qs.parse(location.search);

    if (!!activateParams['id'] && !!activateParams['key']) {
      activate({ id: Number(activateParams['id']), key: String(activateParams['key'])});
    } else {
      message.error("잘못된 접근입니다.", 1);
      navigate("/auth/login")
    }
  }, []);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Loading size="large" />
    </>
  );
};

export default Activate;
